import baseTheme from '../baseTheme';
var MuiAvatar = {
    /* your custom class style overrides here */
    root: {
        // tweak for text alignment
        paddingTop: '3px',
    },
    colorDefault: {
        color: baseTheme.palette.text.primary,
    },
};
export default MuiAvatar;
//# sourceMappingURL=MuiAvatar.js.map